import React from "react";

export default ({ fill }) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.9195 12.9427L11.8521 10.6421V5.95586C11.8521 5.48467 11.4712 5.10379 11 5.10379C10.5288 5.10379 10.1479 5.48467 10.1479 5.95586V11.0682C10.1479 11.3366 10.2741 11.5897 10.4888 11.7499L13.897 14.306C14.0503 14.421 14.2293 14.4764 14.4074 14.4764C14.6672 14.4764 14.9229 14.3597 15.0899 14.1347C15.3728 13.7589 15.2961 13.2247 14.9195 12.9427Z"
      fill={fill || "#339760"}
    />
    <path
      d="M11 0C4.93423 0 0 4.93423 0 11C0 17.0658 4.93423 22 11 22C17.0658 22 22 17.0658 22 11C22 4.93423 17.0658 0 11 0ZM11 20.2959C5.8749 20.2959 1.7041 16.1251 1.7041 11C1.7041 5.8749 5.8749 1.7041 11 1.7041C16.126 1.7041 20.2959 5.8749 20.2959 11C20.2959 16.1251 16.1251 20.2959 11 20.2959Z"
      fill={fill || "#339760"}
    />
  </svg>
);
